// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,//agGridLicenseKey:"ag-Grid_Evaluation_License_Not_For_Production_1Devs4_October_2017__MTUwNzA3MTYwMDAwMA==6423ab765c4b033274bc361920ba6b1b",
  agGridLicenseKey:"Thomson_Reuters_Canada_MultiApp_2Devs11_April_2019__MTU1NDkzNzIwMDAwMA==ed6c7acd2ec6b2e414ac7e6c0518c043",
  //"Evaluation_License_Valid_Until_6_April_2018__MTUyMjk2OTIwMDAwMA==3c1014a234f38b88fe6739d9bd2284df"
  //"ag-Grid_Evaluation_License_Key_Not_for_Production_100Devs1_February_2018__MTUxNzQ0MzIwMDAwMA==21883182ef75f7daa52922779da96852",
  
  webAPIhost:"https://webapi.canadianlawlist.com/Api/",
  //reportsDomain:"http://CL21UATWEBG08/imdbReports/",
   //webAPIhost:"https://webapi.canadianlawlist.com/Api/",
   reportsDomain:"https://delores.lexpert.ca/imdb_reports/",
  userTokenKeyInLocalStorage:"siteCurrentUser",
  azureAd: {
    clientId: "12c3cb7d-de87-4c14-95e8-6b33d9b219af",
    authority: "https://login.microsoftonline.com/keymedia.com"
  }
};
//webAPIhost:"http://localhos:61128/Api/"
//webAPIhost:"http://CL21UATWEBG08:61884/Api/"
